// extracted by mini-css-extract-plugin
export default {"paymentSection":"u8-z","disabled":"v8-z"};